// ============================================
// Offline Indicator Component
// ============================================

import { useState } from 'preact/hooks';
import { useMountEffect } from '@/hooks/useMountEffect';
import { m, AnimatePresence } from 'framer-motion';

export function OfflineIndicator() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useMountEffect(() => {
    const updateOnlineStatus = () => setIsOffline(!navigator.onLine);

    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    };
  });

  return (
    <AnimatePresence>
      {isOffline && (
        <m.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          className="fixed bottom-0 left-0 right-0 z-50 bg-amber-500 text-white px-4 py-3 text-center font-medium shadow-lg safe-bottom"
          role="status"
          aria-live="polite"
        >
          <span aria-hidden="true">&#x1F4F4;</span> You&apos;re offline - Study mode still works!
        </m.div>
      )}
    </AnimatePresence>
  );
}
